import { createContext } from "react";

interface SidebarToggleContextType {
  isLeftCollapsed: boolean;
  isRightCollapsed: boolean;
  toggleLeft: () => void;
  toggleRight: () => void;
}

export const SidebarToggleContext = createContext<SidebarToggleContextType>({
  isLeftCollapsed: false,
  isRightCollapsed: false,
  toggleLeft: () => {},
  toggleRight: () => {},
});
